import React, { useState } from 'react';
import ContactUsApi from 'api/ContactUsApi';

const ContactUsContext = React.createContext('contact-us');

export const ContactUsContextProvider = props => {
  const [result, setResult] = useState({
    response: null,
    processing: false,
    error: null,
  });

  async function handleSend(data) {
    try {
      await ContactUsApi.sendForm(data);
      setResult({
        currentUser: null,
        response: true,
        processing: false,
      });
    } catch (error) {
      setResult({ error, processing: false });
    }
  }

  const { error, processing, response } = result;

  return (
    <ContactUsContext.Provider
      value={{
        result: response,
        error,
        processing,
        onSend: handleSend,
      }}
    >
      {props.children}
    </ContactUsContext.Provider>
  );
};

export default ContactUsContext;



// WEBPACK FOOTER //
// ./src/contexts/ContactUsContext.jsx